<template>
  <div class="app-at-a-glance-table-header" :class="{ 'first-row': isFirstRow }">
    <div class="app-at-a-glance-table-header__column-one" />
    <div v-if="showForecast" class="app-at-a-glance-table-header__column-two">{{ rowData[3] }}</div>
    <div v-if="showForecast" class="app-at-a-glance-table-header__column-three">{{ rowData[4] }}</div>
    <div v-if="showForecast" class="app-at-a-glance-table-header__column-four">{{ rowData[5] }}</div>
    <div v-if="showForecast" class="app-at-a-glance-table-header__column-five">{{ rowData[6] }}</div>
    <div v-if="!showForecast" class="app-at-a-glance-table-header__column-six">{{ parseTitle('chart', rowData[1]) }}</div>
    <div v-if="!showForecast" class="app-at-a-glance-table-header__column-seven">{{ parseTitle('chart', rowData[2]) }}</div>
  </div>
</template>

<script>

  export default {
    name: 'AppAtAGlanceTableHeaderRow',
    components: {
    },
    props: {
      rowData: {
        type: Object,
        required: true,
      },
      showForecast: {
        type: Boolean,
        required: true,
      },     
      isFirstRow: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      parseTitle(type, title) {
        if (type === 'chart') {
          return title.replace('Historical', '');
        }
        return title;
      },
    }
  };
</script>
<style scoped lang="scss">
  .app-at-a-glance-table-header {
    background: var(--itr-blue-mid);
    width: 100%;
    height: 36px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    color: var(--itr-white);
    font-size: 12px;
    font-weight: bold;
    &.first-row {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    &__column-one{
      width: 48%;
    }
    &__column-two {
      line-height: 1;
    } 
    &__column-two, &__column-three, &__column-four, &__column-five {
      text-align: center;
      width: 13%;
    }
    &__column-six, &__column-seven {
      text-align: center;
      width: 26%;
    }
  }
</style>